<template>
  <div class="settings-container" v-if="props.data">
    
      <div class="section-header" v-if="props.data.integrations">
        <h3>Integrations</h3>
        <el-select v-if="props.canEdit" v-model="props.data.integrations.permission" default-first-option @change="handleIntegrationsChange">
          <el-option v-for="item in props.data.integrations.permissionOption" :key="item.type" :label="item.name"
            :value="item.type" />
        </el-select>
        <span v-else>{{switchParentText(props.data.integrations.permission)}}</span>
      </div>
    
      <div class="setting-item indented" v-if="props.data.domainSettings">
        <span>Domain settings</span>
        <div v-if="props.data.integrations.permission === 100">
          <Switch v-if="props.canEdit" :checked="props.data.domainSettings.permission === 100"
            @click.native="switchItem(props.data, 'domainSettings.permission')" />
          <span v-else>{{ switchText(props.data.domainSettings.permission) }}</span>
        </div>
      </div>

      <Alert v-if="!ScriptYes"  svgName="lock" className="yellow yellow3">
          <p>
            Your current plan does not have access to this feature.
            <a :href="`mailto:anchor@motom.me?subject=${Store.state.user_data.merchant_account.merchant_display_name} - Upgrade to Custom Subdomain&body= Please provide your name and contact info. A representative will contact you in 1-2 business days.`" target="_blank">Contact us</a> 
            to upgrade your account
          </p>
      </Alert>

      <div class="setting-item indented" v-if="props.data.scriptManagerSettings">
        <span>Script Manager settings</span>
        <div v-if="props.data.integrations.permission === 100">
          <Switch v-if="props.canEdit" :checked="props.data.scriptManagerSettings.permission === 100"
            @click.native="ScriptYes?switchItem(props.data, 'scriptManagerSettings.permission'):null" :disabled="!ScriptYes"/>
          <span v-else>{{ switchText(props.data.scriptManagerSettings.permission) }}</span>
        </div>
      </div>

      <!-- header -->
      <div class="section-header section-header-2" v-if="props.data.privacySettings">
        <h3>Privacy settings</h3>
        <el-select v-if="props.canEdit" v-model="props.data.privacySettings.permission" default-first-option @change="handlePrivacyChange">
          <el-option v-for="item in props.data.privacySettings.permissionOption" :key="item.type" :label="item.name"
            :value="item.type" />
        </el-select>
        <span v-else>{{switchParentText(props.data.privacySettings.permission)}}</span>
      </div>

      <div class="setting-item indented" v-if="props.data.addOrEditTermsAndConditions">
        <span>Add/edit Terms & Conditions</span>
        <div v-if="props.data.privacySettings.permission === 100">
          <Switch v-if="props.canEdit" :checked="props.data.addOrEditTermsAndConditions.permission === 100"
            @click.native="switchItem(props.data, 'addOrEditTermsAndConditions.permission')" />
          <span v-else>{{ switchText(props.data.addOrEditTermsAndConditions.permission) }}</span>
        </div>
      </div>

      <div class="setting-item indented" v-if="props.data.addOrEditPrivacyPolicy">
        <span>Add/edit Privacy Policy</span>
        <div v-if="props.data.privacySettings.permission === 100">
          <Switch v-if="props.canEdit" :checked="props.data.addOrEditPrivacyPolicy.permission === 100"
            @click.native="switchItem(props.data, 'addOrEditPrivacyPolicy.permission')" />
          <span v-else>{{ switchText(props.data.addOrEditPrivacyPolicy.permission) }}</span>
        </div>
      </div>
  </div>
</template>

<script setup>
import { reactive,computed,onMounted } from 'vue';
import Switch from '@/components/ui/Switch.vue';
import { ElSelect, ElOption } from 'element-plus';
import { useTeamFunction } from './teamFunction';
import Alert from '@/components/settings/SettingAlert.vue';
import Store from '@/store/index.js';

const props = defineProps({
  data: {
    type: Object,
    default: () => ({})
  },
  isOwner: {
    type: Boolean,
    default: false
  },
  canEdit: {
    type: Boolean,
    default: false
  }
});
const { switchItem,switchText,switchParentText } = useTeamFunction();

const ScriptYes = computed(() => {
  return Store.state.user_data?.merchant_account?.is_enable_script_manager;
});
//+++++++++++++++++++++++++++++
const handleIntegrationsChange = (event) => {
  props.data.domainSettings.permission = event;
  props.data.scriptManagerSettings.permission = event;
};
const handlePrivacyChange = (event) => {
  props.data.addOrEditTermsAndConditions.permission = event;
  props.data.addOrEditPrivacyPolicy.permission = event;
};

// +++++++++++++++++++++++++++++
// +++++++++++++++++++++++++++++
onMounted(() => {
 
 setTimeout(()=>{
   if (!Store.state.user_data?.merchant_account?.is_enable_script_manager) {
     props.data.scriptManagerSettings.permission = 0;
   }
 },1000)

});
</script>
